import { useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
// import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
// import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
// import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
// import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import GroupsIcon from '@mui/icons-material/Groups';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import RoomPreferencesOutlinedIcon from '@mui/icons-material/RoomPreferencesOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          width: "290px !important",
        },
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]} style={{ display: "flex", alignSelf: "center" }}>
                  <img
                    alt="logo"
                    width="30px"
                    height="30px"
                    src={`../../assets/favicon.ico`}
                    style={{ cursor: "pointer", }}
                  /><span>&nbsp;AIRBOOKS</span>
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  src={`../../assets/user.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  Ed Roh
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  VP Fancy Admin
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Visitors"
              to="/visitor"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <SubMenu
              title="Hajj Kafela" component={<Link to="/team" />}
              icon={<HomeWorkIcon />} >
              <MenuItem component={<Link to="/invoices" />}> Pre-Registration </MenuItem>
              <MenuItem> Main-Registration </MenuItem>
              <MenuItem> Package </MenuItem>
              <MenuItem> Group </MenuItem>
            </SubMenu>
            <SubMenu
              title="Umrah"
              icon={<HomeWorkIcon />} >
              <MenuItem to="/invoices"> Package </MenuItem>
              <MenuItem> Group </MenuItem>
            </SubMenu>

            <SubMenu
              title="Manpower Managemnt"
              icon={<GroupsIcon />} >
              <MenuItem to="/invoices"> All customer </MenuItem>
              <MenuItem> Embassy Form List </MenuItem>
              <MenuItem> Embassy List </MenuItem>
            </SubMenu>
            <Item
              title="Visa Processing"
              to="/visaprocessing"
              icon={<ContactsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Passport Processing"
              to="/passportprocessing"
              icon={<ReceiptOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <SubMenu
              title="Ticket Management"
              icon={<ConfirmationNumberOutlinedIcon />} >
              <MenuItem><Link to="/ticketairlines"> Ticketing Airlines List</Link></MenuItem>
              <MenuItem><Link to="/ticketpurchase"> Ticket Purchase</Link></MenuItem>
              <MenuItem><Link to="/ticketsales"> Ticket Sales</Link></MenuItem>
            </SubMenu>
            <SubMenu
              title="Marketing Management"
              icon={<PollOutlinedIcon />} >
              <MenuItem><Link to="/marketmanagement">SMS Sending System</Link></MenuItem>
            </SubMenu>
            <SubMenu
              title="Accounts"
              icon={<PersonAddAltOutlinedIcon />} >
              <MenuItem to="/invoices"> Pre Hajj Payment </MenuItem>
              <MenuItem to="/invoices"> Main Hajj Payment </MenuItem>
              <MenuItem to="/invoices"> Umrah Payment </MenuItem>
              <MenuItem to="/invoices"> Student Payment </MenuItem>
              <MenuItem to="/invoices"> Manpower Payment </MenuItem>
              <MenuItem to="/invoices"> Visa Payment </MenuItem>
              <MenuItem to="/invoices"> Passport Payment </MenuItem>
              <MenuItem to="/invoices"> Agent Payment </MenuItem>
              <MenuItem to="/invoices"> Daily Account </MenuItem>
            </SubMenu>
            <SubMenu
              title="Reports"
              icon={<TextSnippetOutlinedIcon />} >
              <MenuItem to="/invoices"> Agent Ledger </MenuItem>
              <MenuItem> Ticket Purchase </MenuItem>
              <MenuItem> Ticket Sales </MenuItem>
              <MenuItem> Visitors Report </MenuItem>
              <MenuItem> Master Payment Report </MenuItem>
              <MenuItem> All Hajji Registration Report </MenuItem>
              <MenuItem> Payment Ledger </MenuItem>
              <MenuItem> Students Report </MenuItem>
              <MenuItem> Manpower Report </MenuItem>
              <MenuItem> Bank Ledger </MenuItem>
              <MenuItem> Passport Report </MenuItem>
              <MenuItem> Manpower Master Report </MenuItem>
            </SubMenu>
            <SubMenu
              title="Settings"
              icon={<SettingsOutlinedIcon />} >
              <MenuItem><Link to="/agentlist"> Agent List</Link></MenuItem>
              <MenuItem><Link to="/banklist"> Bank </Link></MenuItem>
              <MenuItem><Link to="/countrylist"> Country</Link> </MenuItem>
              <MenuItem> <Link to="/supplierinfo">Supplier Info </Link></MenuItem>
              <MenuItem><Link to="/projectsetup"> Project Setup</Link> </MenuItem>
            </SubMenu>
            <Item
              title="Subscriptions"
              to="/contacts"
              icon={<PersonOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Company Info"
              to="/companyinfo"
              icon={<RoomPreferencesOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="User Documentation"
              to="/Userinfo"
              icon={<FolderSharedOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Pages
            </Typography> */}
          </Box>
        </Menu>
      </ProSidebar>
    </Box >
  );
};

export default Sidebar;
